//import 'es6-promise/auto'
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import store from './store'
import router from './router'
import VueCarousel from 'vue-carousel'
//import vSelect from 'vue-select'
import lightbox from 'vlightbox'
import VueI18n from 'vue-i18n'
import VTooltip from 'v-tooltip'
import VueSweetAlert from 'vue-sweetalert'
import Acl from 'vue-acl'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'
import VModal from 'vue-js-modal'
import nl from './locales/nl'
import fr from './locales/fr'
import * as types from './store/mutation-types'

window._ = require('lodash')

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(VueI18n)
Vue.use(VueCarousel)
//Vue.use(vSelect)
Vue.use(lightbox)
Vue.use(VTooltip)
Vue.use(VModal)
Vue.use(VueSweetAlert)
Vue.use(Notifications, { velocity })
Vue.use(Acl, { router: router, init: 'public' })

var messages = {
    nl: nl,
    fr: fr
}

// Create VueI18n instance with options
let i18n = new VueI18n({
    locale: window.localStorage.getItem('language'),
    fallbackLocale: 'nl',
    messages // set locale messages
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    i18n,
    //template: '<App/>',
    computed: {
        token() {
            return this.$store.getters.token
        }
    },
    created() {
        if (window.sessionStorage.getItem('customer') && window.sessionStorage.getItem('token')) {
            this.$store.commit(types.SET_HEADER, JSON.parse(window.sessionStorage.getItem('token')))
            this.$store.dispatch('validateCustomer')
        }

        if (localStorage.getItem('shoppingCart')) {
            this.$store.commit(types.SET_PRODUCTS_IN_SHOPPING_CART, JSON.parse(localStorage.getItem('shoppingCart')))
        }
        if (localStorage.getItem('language')) {
            this.$i18n.locale = localStorage.getItem('language')
        } else {
            this.$i18n.locale = 'nl'
        }
    },
    components: { App },
    render: h => h(App)
})
